import { makeStyles } from '@material-ui/core/styles'
import equalizer from '@v4/images/equalizer.gif'

const useStyles = makeStyles(
	theme => ({
		root: {
			position: 'relative',
			width: '100%',
			height: '100%',
		},
		container: {
			'&:hover': {
				cursor: ({ isBuilderMode }) => (isBuilderMode ? 'default' : 'pointer'),
			},
			position: 'relative',
			width: '100%',
		},

		image: {
			display: 'block',
			paddingTop: '57.2%',
			marginBottom: theme.spacing(3),

			'& picture': {
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
			},

			'& img': {
				height: '100%',
				width: '100%',
				objectFit: 'cover',
			},
		},
		playStatus: {
			position: 'absolute',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			top: 0,
			right: 0,
			left: 0,
			bottom: 0,
			backgroundPositionX: 'center',
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			backgroundColor: 'rgba(0, 0, 0, 0.4)',

			'&:before': {
				content: '""',
				backgroundImage: `url("${equalizer}")`,
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat',
				position: 'absolute',
				width: 50,
				height: 50,
				zIndex: 1,

				[theme.breakpoints.down('xs')]: {
					width: 40,
					height: 40,
				},
			},
		},
		text: {
			marginBottom: theme.spacing(0.5),

			[theme.breakpoints.down('xs')]: {
				'& *': {
					textAlign: ({ mobileAlignment }) => mobileAlignment || null,
				},
			},
		},
	}),
	{ name: 'Video-Video6-item' },
)

export default useStyles
